export default {"src":"/_next/static/media/icon-marketplace-planet-activity.87cd13ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};